module.exports = __webpack_public_path__ + "fonts/Barlow-600.eb2f99b.woff2";